module.exports = __webpack_public_path__ + "img/lte-label.5c846940.svg";